<template>
  <div class="statistics">
    <div class="stat">
      <span class="stat-label">Fatigue level: </span>
      <span class="stat-stat">{{ existingEntry.data.fatigueLevel }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stats",
  props: ["existingEntry"]
}
</script>

<style>

</style>
